// mutations
const SET_RESULTFASILITAS = (state, payload) => {
  state.list_fasilitas = payload;
};
const SET_RESULTFASILITASID = (state, payload) => {
  state.res_fasilitas_by_id = payload;
};
const SET_USERID = (state, payload) => {
  state.id_user = payload;
};
const SET_INPUTFASILITAS = (state, payload) => {
  state.tempFasilitas = payload;
};

const SET_INPUTMASTERFASILITAS = (state, payload) => {
  state.tempMasterFasilitas = payload;
};
const SET_IDMASTERFACILITY = (state, payload) => {
  state.idMasterFacility = payload;
};
const SET_ID = (state, payload) => {
  state.idFasilitas = payload;
};
const SET_LIST_APPROVAL = (state, payload) => {
  state.list_approval = payload;
};
export default {
  SET_RESULTFASILITAS,
  SET_RESULTFASILITASID,
  SET_USERID,
  SET_INPUTFASILITAS,
  SET_LIST_APPROVAL,
  SET_INPUTMASTERFASILITAS,
  SET_IDMASTERFACILITY,
  SET_ID
};
